/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import Layout from 'components/Layout';
import { SafeTraining, AtcTraining } from 'components/TrainingDetailComponents';
import trainingsApi from 'utils/trainingsApi';

const TrainingDetailPage = ({ path, trainingId }) => {
  const [training, setTraining] = useState({});

  useEffect(() => {
    axios
      .get(`${trainingsApi.detail}${trainingId}`)
      .then(({ data }) => setTraining(data))
      .catch(() => {
        if (typeof window !== `undefined`)
          window.location.replace(`/trainings/`);
      });
  }, []);

  return training && training.trainingId ? (
    <>
      {training.trainingId.startsWith('A') ? (
        <AtcTraining training={training} path={path} />
      ) : (
        <SafeTraining training={training} path={path} />
      )}
    </>
  ) : (
    <Layout path={path} lightTheme>
      <div className="center" style={{ padding: '50px 0' }}>
        <p>Loading...</p>
      </div>
    </Layout>
  );
};

TrainingDetailPage.propTypes = {
  path: PropTypes.string.isRequired,
  trainingId: PropTypes.string,
};

export default TrainingDetailPage;
